const EMR_HEADER = 0x00000001;
const EMR_POLYBEZIER = 0x00000002;
const EMR_POLYGON = 0x00000003;
const EMR_POLYLINE = 0x00000004;
const EMR_SETWINDOWEXTEX = 0x00000009;
const EMR_SETWINDOWORGEX = 0x0000000A;
const EMR_SETVIEWPORTEXTEX = 0x0000000B;
const EMR_SETVIEWPORTORGEX = 0x0000000C;
const EMR_EOF = 0x0000000E;
const EMR_SETBKMODE = 0x00000012;
const EMR_SETPOLYFILLMODE = 0x00000013;
const EMR_SETTEXTCOLOR = 0x00000018;
const EMR_SETBKCOLOR = 0x00000019;
const EMR_MOVETOEX = 0x0000001B;
const EMR_SAVEDC = 0x00000021;
const EMR_RESTOREDC = 0x00000022;
const EMR_SELECTOBJECT = 0x00000025;
const EMR_CREATEPEN = 0x00000026;
const EMR_CREATEBRUSHINDIRECT = 0x00000027;
const EMR_DELETEOBJECT = 0x00000028;
const EMR_ELLIPSE = 0x0000002A;
const EMR_RECTANGLE = 0x0000002B;
const EMR_ROUNDRECT = 0x0000002C;
const EMR_ARC = 0x0000002D;
const EMR_CHORD = 0x0000002E;
const EMR_PIE = 0x0000002F;
const EMR_LINETO = 0x00000036;
const EMR_BEGINPATH = 0x0000003B;
const EMR_ENDPATH = 0x0000003C;
const EMR_CLOSEFIGURE = 0x0000003D;
const EMR_FILLPATH = 0x0000003E;
const EMR_STROKEANDFILLPATH = 0x0000003F;
const EMR_STROKEPATH = 0x00000040;
const EMR_EXTTEXTOUTA = 0x00000053;
const EMR_EXTTEXTOUTW = 0x00000054;
const EMR_POLYBEZIER16 = 0x00000055;
const EMR_POLYGON16 = 0x00000056;
const EMR_POLYLINE16 = 0x00000057;
export class EMFRenderer {
    constructor(ctx) {
        this.header = null;
        this.stateStack = [];
        this.objects = new Map();
        this.ctx = ctx;
        this.state = {
            currentX: 0,
            currentY: 0,
            textColor: '#000000',
            bkColor: '#ffffff',
            fillColor: '#ffffff',
            strokeColor: '#000000',
            lineWidth: 1,
            bkMode: 1,
            polyFillMode: 1,
            windowOrg: { x: 0, y: 0 },
            windowExt: { x: 1, y: 1 },
            viewportOrg: { x: 0, y: 0 },
            viewportExt: { x: 1, y: 1 },
        };
    }
    render(buffer) {
        let dataView;
        if (buffer instanceof Buffer) {
            const buf = buffer;
            dataView = new DataView(buf.buffer, buf.byteOffset, buf.byteLength);
        }
        else {
            dataView = new DataView(buffer);
        }
        this.header = this.parseHeader(dataView);
        const width = this.header.bounds.right - this.header.bounds.left;
        const height = this.header.bounds.bottom - this.header.bounds.top;
        this.state.viewportExt = { x: width, y: height };
        this.state.windowExt = { x: width, y: height };
        let offset = this.header.recordSize;
        let recordCount = 0;
        while (offset < dataView.byteLength && recordCount < this.header.numRecords) {
            const record = this.parseRecord(dataView, offset);
            if (record.type === EMR_EOF) {
                break;
            }
            this.renderRecord(record);
            offset += record.size;
            recordCount++;
        }
    }
    parseHeader(dv) {
        const recordType = dv.getUint32(0, true);
        const recordSize = dv.getUint32(4, true);
        if (recordType !== EMR_HEADER) {
            throw new Error(`Invalid EMF file: expected header type ${EMR_HEADER}, got ${recordType} (buffer length: ${dv.byteLength})`);
        }
        const bounds = {
            left: dv.getInt32(8, true),
            top: dv.getInt32(12, true),
            right: dv.getInt32(16, true),
            bottom: dv.getInt32(20, true),
        };
        const frame = {
            left: dv.getInt32(24, true),
            top: dv.getInt32(28, true),
            right: dv.getInt32(32, true),
            bottom: dv.getInt32(36, true),
        };
        const signature = String.fromCharCode(dv.getUint8(40), dv.getUint8(41), dv.getUint8(42), dv.getUint8(43));
        if (signature !== ' EMF') {
            throw new Error(`Invalid EMF signature: ${signature}`);
        }
        const version = dv.getUint32(44, true);
        const fileSize = dv.getUint32(48, true);
        const numRecords = dv.getUint32(52, true);
        const numHandles = dv.getUint16(56, true);
        return {
            recordType,
            recordSize,
            bounds,
            frame,
            signature,
            version,
            fileSize,
            numRecords,
            numHandles,
        };
    }
    parseRecord(dv, offset) {
        const type = dv.getUint32(offset, true);
        const size = dv.getUint32(offset + 4, true);
        const data = new DataView(dv.buffer, dv.byteOffset + offset + 8, size - 8);
        return { type, size, data };
    }
    renderRecord(record) {
        switch (record.type) {
            case EMR_HEADER:
                break;
            case EMR_SETWINDOWEXTEX:
                this.state.windowExt.x = record.data.getInt32(0, true);
                this.state.windowExt.y = record.data.getInt32(4, true);
                break;
            case EMR_SETWINDOWORGEX:
                this.state.windowOrg.x = record.data.getInt32(0, true);
                this.state.windowOrg.y = record.data.getInt32(4, true);
                break;
            case EMR_SETVIEWPORTEXTEX:
                this.state.viewportExt.x = record.data.getInt32(0, true);
                this.state.viewportExt.y = record.data.getInt32(4, true);
                break;
            case EMR_SETVIEWPORTORGEX:
                this.state.viewportOrg.x = record.data.getInt32(0, true);
                this.state.viewportOrg.y = record.data.getInt32(4, true);
                break;
            case EMR_SETTEXTCOLOR:
                this.state.textColor = this.parseColorRef(record.data.getUint32(0, true));
                break;
            case EMR_SETBKCOLOR:
                this.state.bkColor = this.parseColorRef(record.data.getUint32(0, true));
                break;
            case EMR_SETBKMODE:
                this.state.bkMode = record.data.getUint32(0, true);
                break;
            case EMR_SETPOLYFILLMODE:
                this.state.polyFillMode = record.data.getUint32(0, true);
                break;
            case EMR_MOVETOEX:
                this.state.currentX = record.data.getInt32(0, true);
                this.state.currentY = record.data.getInt32(4, true);
                break;
            case EMR_LINETO:
                this.renderLineTo(record.data);
                break;
            case EMR_RECTANGLE:
                this.renderRectangle(record.data);
                break;
            case EMR_ELLIPSE:
                this.renderEllipse(record.data);
                break;
            case EMR_POLYGON:
            case EMR_POLYGON16:
                this.renderPolygon(record.data, record.type === EMR_POLYGON16);
                break;
            case EMR_POLYLINE:
            case EMR_POLYLINE16:
                this.renderPolyline(record.data, record.type === EMR_POLYLINE16);
                break;
            case EMR_POLYBEZIER:
            case EMR_POLYBEZIER16:
                this.renderPolyBezier(record.data, record.type === EMR_POLYBEZIER16);
                break;
            case EMR_ROUNDRECT:
                this.renderRoundRect(record.data);
                break;
            case EMR_ARC:
                this.renderArc(record.data);
                break;
            case EMR_PIE:
                this.renderPie(record.data);
                break;
            case EMR_CHORD:
                this.renderChord(record.data);
                break;
            case EMR_EXTTEXTOUTA:
            case EMR_EXTTEXTOUTW:
                this.renderExtTextOut(record.data, record.type === EMR_EXTTEXTOUTW);
                break;
            case EMR_CREATEPEN:
                this.createPen(record.data);
                break;
            case EMR_CREATEBRUSHINDIRECT:
                this.createBrushIndirect(record.data);
                break;
            case EMR_SELECTOBJECT:
                this.selectObject(record.data);
                break;
            case EMR_DELETEOBJECT:
                this.deleteObject(record.data);
                break;
            case EMR_SAVEDC:
                this.stateStack.push({ ...this.state });
                this.ctx.save();
                break;
            case EMR_RESTOREDC:
                const savedState = this.stateStack.pop();
                if (savedState) {
                    this.state = savedState;
                }
                this.ctx.restore();
                break;
            case EMR_BEGINPATH:
                this.ctx.beginPath();
                break;
            case EMR_ENDPATH:
                break;
            case EMR_CLOSEFIGURE:
                this.ctx.closePath();
                break;
            case EMR_FILLPATH:
                this.ctx.fillStyle = this.state.fillColor;
                this.ctx.fill(this.state.polyFillMode === 1 ? 'evenodd' : 'nonzero');
                break;
            case EMR_STROKEPATH:
                this.ctx.strokeStyle = this.state.strokeColor;
                this.ctx.lineWidth = this.state.lineWidth;
                this.ctx.stroke();
                break;
            case EMR_STROKEANDFILLPATH:
                this.ctx.fillStyle = this.state.fillColor;
                this.ctx.fill(this.state.polyFillMode === 1 ? 'evenodd' : 'nonzero');
                this.ctx.strokeStyle = this.state.strokeColor;
                this.ctx.lineWidth = this.state.lineWidth;
                this.ctx.stroke();
                break;
            case EMR_EOF:
                break;
            default:
                break;
        }
    }
    transformX(x) {
        const wx = this.state.windowExt.x || 1;
        const vx = this.state.viewportExt.x || 1;
        return ((x - this.state.windowOrg.x) * vx / wx) + this.state.viewportOrg.x;
    }
    transformY(y) {
        const wy = this.state.windowExt.y || 1;
        const vy = this.state.viewportExt.y || 1;
        return ((y - this.state.windowOrg.y) * vy / wy) + this.state.viewportOrg.y;
    }
    parseColorRef(colorRef) {
        const r = colorRef & 0xFF;
        const g = (colorRef >> 8) & 0xFF;
        const b = (colorRef >> 16) & 0xFF;
        return `rgb(${r}, ${g}, ${b})`;
    }
    renderLineTo(data) {
        const x = data.getInt32(0, true);
        const y = data.getInt32(4, true);
        this.ctx.beginPath();
        this.ctx.moveTo(this.transformX(this.state.currentX), this.transformY(this.state.currentY));
        this.ctx.lineTo(this.transformX(x), this.transformY(y));
        this.ctx.strokeStyle = this.state.strokeColor;
        this.ctx.lineWidth = this.state.lineWidth;
        this.ctx.stroke();
        this.state.currentX = x;
        this.state.currentY = y;
    }
    renderRectangle(data) {
        const left = data.getInt32(0, true);
        const top = data.getInt32(4, true);
        const right = data.getInt32(8, true);
        const bottom = data.getInt32(12, true);
        const x = this.transformX(left);
        const y = this.transformY(top);
        const width = this.transformX(right) - x;
        const height = this.transformY(bottom) - y;
        this.ctx.fillStyle = this.state.fillColor;
        this.ctx.fillRect(x, y, width, height);
        this.ctx.strokeStyle = this.state.strokeColor;
        this.ctx.lineWidth = this.state.lineWidth;
        this.ctx.strokeRect(x, y, width, height);
    }
    renderEllipse(data) {
        const left = data.getInt32(0, true);
        const top = data.getInt32(4, true);
        const right = data.getInt32(8, true);
        const bottom = data.getInt32(12, true);
        const x = this.transformX(left);
        const y = this.transformY(top);
        const width = this.transformX(right) - x;
        const height = this.transformY(bottom) - y;
        const cx = x + width / 2;
        const cy = y + height / 2;
        const rx = Math.abs(width / 2);
        const ry = Math.abs(height / 2);
        this.ctx.beginPath();
        this.ctx.ellipse(cx, cy, rx, ry, 0, 0, 2 * Math.PI);
        this.ctx.fillStyle = this.state.fillColor;
        this.ctx.fill();
        this.ctx.strokeStyle = this.state.strokeColor;
        this.ctx.lineWidth = this.state.lineWidth;
        this.ctx.stroke();
    }
    renderPolygon(data, is16bit) {
        const count = data.getUint32(16, true);
        if (count < 2) {
            return;
        }
        this.ctx.beginPath();
        const pointSize = is16bit ? 4 : 8;
        const pointsOffset = 20;
        for (let i = 0; i < count; i++) {
            const offset = pointsOffset + (i * pointSize);
            const x = is16bit ? data.getInt16(offset, true) : data.getInt32(offset, true);
            const y = is16bit ? data.getInt16(offset + (is16bit ? 2 : 4), true) : data.getInt32(offset + 4, true);
            if (i === 0) {
                this.ctx.moveTo(this.transformX(x), this.transformY(y));
            }
            else {
                this.ctx.lineTo(this.transformX(x), this.transformY(y));
            }
        }
        this.ctx.closePath();
        this.ctx.fillStyle = this.state.fillColor;
        this.ctx.fill(this.state.polyFillMode === 1 ? 'evenodd' : 'nonzero');
        this.ctx.strokeStyle = this.state.strokeColor;
        this.ctx.lineWidth = this.state.lineWidth;
        this.ctx.stroke();
    }
    renderPolyline(data, is16bit) {
        const count = data.getUint32(16, true);
        if (count < 2) {
            return;
        }
        this.ctx.beginPath();
        const pointSize = is16bit ? 4 : 8;
        const pointsOffset = 20;
        for (let i = 0; i < count; i++) {
            const offset = pointsOffset + (i * pointSize);
            const x = is16bit ? data.getInt16(offset, true) : data.getInt32(offset, true);
            const y = is16bit ? data.getInt16(offset + (is16bit ? 2 : 4), true) : data.getInt32(offset + 4, true);
            if (i === 0) {
                this.ctx.moveTo(this.transformX(x), this.transformY(y));
            }
            else {
                this.ctx.lineTo(this.transformX(x), this.transformY(y));
            }
        }
        this.ctx.strokeStyle = this.state.strokeColor;
        this.ctx.lineWidth = this.state.lineWidth;
        this.ctx.stroke();
    }
    renderPolyBezier(data, is16bit) {
        const count = data.getUint32(16, true);
        if (count < 4 || (count - 1) % 3 !== 0) {
            return;
        }
        this.ctx.beginPath();
        const pointSize = is16bit ? 4 : 8;
        const pointsOffset = 20;
        const x0 = is16bit ? data.getInt16(pointsOffset, true) : data.getInt32(pointsOffset, true);
        const y0 = is16bit ? data.getInt16(pointsOffset + (is16bit ? 2 : 4), true) : data.getInt32(pointsOffset + 4, true);
        this.ctx.moveTo(this.transformX(x0), this.transformY(y0));
        for (let i = 1; i < count; i += 3) {
            const offset1 = pointsOffset + (i * pointSize);
            const offset2 = pointsOffset + ((i + 1) * pointSize);
            const offset3 = pointsOffset + ((i + 2) * pointSize);
            const cp1x = is16bit ? data.getInt16(offset1, true) : data.getInt32(offset1, true);
            const cp1y = is16bit ? data.getInt16(offset1 + (is16bit ? 2 : 4), true) : data.getInt32(offset1 + 4, true);
            const cp2x = is16bit ? data.getInt16(offset2, true) : data.getInt32(offset2, true);
            const cp2y = is16bit ? data.getInt16(offset2 + (is16bit ? 2 : 4), true) : data.getInt32(offset2 + 4, true);
            const x = is16bit ? data.getInt16(offset3, true) : data.getInt32(offset3, true);
            const y = is16bit ? data.getInt16(offset3 + (is16bit ? 2 : 4), true) : data.getInt32(offset3 + 4, true);
            this.ctx.bezierCurveTo(this.transformX(cp1x), this.transformY(cp1y), this.transformX(cp2x), this.transformY(cp2y), this.transformX(x), this.transformY(y));
        }
        this.ctx.strokeStyle = this.state.strokeColor;
        this.ctx.lineWidth = this.state.lineWidth;
        this.ctx.stroke();
    }
    renderRoundRect(data) {
        const left = data.getInt32(0, true);
        const top = data.getInt32(4, true);
        const right = data.getInt32(8, true);
        const bottom = data.getInt32(12, true);
        const cornerWidth = data.getInt32(16, true);
        const cornerHeight = data.getInt32(20, true);
        const x = this.transformX(left);
        const y = this.transformY(top);
        const width = this.transformX(right) - x;
        const height = this.transformY(bottom) - y;
        const radius = Math.min(cornerWidth / 2, cornerHeight / 2);
        this.ctx.beginPath();
        this.ctx.roundRect(x, y, width, height, radius);
        this.ctx.fillStyle = this.state.fillColor;
        this.ctx.fill();
        this.ctx.strokeStyle = this.state.strokeColor;
        this.ctx.lineWidth = this.state.lineWidth;
        this.ctx.stroke();
    }
    renderArc(data) {
        const left = data.getInt32(0, true);
        const top = data.getInt32(4, true);
        const right = data.getInt32(8, true);
        const bottom = data.getInt32(12, true);
        const startX = data.getInt32(16, true);
        const startY = data.getInt32(20, true);
        const endX = data.getInt32(24, true);
        const endY = data.getInt32(28, true);
        this.renderArcHelper(left, top, right, bottom, startX, startY, endX, endY, false);
    }
    renderPie(data) {
        const left = data.getInt32(0, true);
        const top = data.getInt32(4, true);
        const right = data.getInt32(8, true);
        const bottom = data.getInt32(12, true);
        const startX = data.getInt32(16, true);
        const startY = data.getInt32(20, true);
        const endX = data.getInt32(24, true);
        const endY = data.getInt32(28, true);
        this.renderArcHelper(left, top, right, bottom, startX, startY, endX, endY, true);
        this.ctx.fillStyle = this.state.fillColor;
        this.ctx.fill();
    }
    renderChord(data) {
        const left = data.getInt32(0, true);
        const top = data.getInt32(4, true);
        const right = data.getInt32(8, true);
        const bottom = data.getInt32(12, true);
        const startX = data.getInt32(16, true);
        const startY = data.getInt32(20, true);
        const endX = data.getInt32(24, true);
        const endY = data.getInt32(28, true);
        const x = this.transformX(left);
        const y = this.transformY(top);
        const width = this.transformX(right) - x;
        const height = this.transformY(bottom) - y;
        const cx = x + width / 2;
        const cy = y + height / 2;
        const rx = Math.abs(width / 2);
        const ry = Math.abs(height / 2);
        const startAngle = Math.atan2(startY - cy, startX - cx);
        const endAngle = Math.atan2(endY - cy, endX - cx);
        this.ctx.beginPath();
        this.ctx.ellipse(cx, cy, rx, ry, 0, startAngle, endAngle);
        this.ctx.closePath();
        this.ctx.fillStyle = this.state.fillColor;
        this.ctx.fill();
        this.ctx.strokeStyle = this.state.strokeColor;
        this.ctx.lineWidth = this.state.lineWidth;
        this.ctx.stroke();
    }
    renderArcHelper(left, top, right, bottom, startX, startY, endX, endY, closePath) {
        const x = this.transformX(left);
        const y = this.transformY(top);
        const width = this.transformX(right) - x;
        const height = this.transformY(bottom) - y;
        const cx = x + width / 2;
        const cy = y + height / 2;
        const rx = Math.abs(width / 2);
        const ry = Math.abs(height / 2);
        const startAngle = Math.atan2(startY - cy, startX - cx);
        const endAngle = Math.atan2(endY - cy, endX - cx);
        this.ctx.beginPath();
        if (closePath) {
            this.ctx.moveTo(cx, cy);
        }
        this.ctx.ellipse(cx, cy, rx, ry, 0, startAngle, endAngle);
        if (closePath) {
            this.ctx.closePath();
        }
        this.ctx.strokeStyle = this.state.strokeColor;
        this.ctx.lineWidth = this.state.lineWidth;
        this.ctx.stroke();
    }
    renderExtTextOut(data, isUnicode) {
        const boundsLeft = data.getInt32(0, true);
        const boundsTop = data.getInt32(4, true);
        const offString = data.getUint32(24, true);
        const stringLength = data.getUint32(28, true);
        if (stringLength === 0) {
            return;
        }
        let text = '';
        const textOffset = offString - 8;
        if (textOffset < 0 || textOffset >= data.byteLength) {
            return;
        }
        const bytesNeeded = isUnicode ? (stringLength * 2) : stringLength;
        if (textOffset + bytesNeeded > data.byteLength) {
            return;
        }
        if (isUnicode) {
            for (let i = 0; i < stringLength; i++) {
                const charCode = data.getUint16(textOffset + (i * 2), true);
                text += String.fromCharCode(charCode);
            }
        }
        else {
            for (let i = 0; i < stringLength; i++) {
                const charCode = data.getUint8(textOffset + i);
                text += String.fromCharCode(charCode);
            }
        }
        const x = this.transformX(boundsLeft);
        const y = this.transformY(boundsTop);
        this.ctx.fillStyle = this.state.textColor;
        this.ctx.fillText(text, x, y);
    }
    createPen(data) {
        const index = data.getUint32(0, true);
        const style = data.getUint32(4, true);
        const width = data.getUint32(8, true);
        const colorRef = data.getUint32(16, true);
        this.objects.set(index, {
            type: 'pen',
            style,
            width,
            color: this.parseColorRef(colorRef),
        });
    }
    createBrushIndirect(data) {
        const index = data.getUint32(0, true);
        const style = data.getUint32(4, true);
        const colorRef = data.getUint32(8, true);
        const hatch = data.getUint32(12, true);
        this.objects.set(index, {
            type: 'brush',
            style,
            color: this.parseColorRef(colorRef),
            hatch,
        });
    }
    selectObject(data) {
        const index = data.getUint32(0, true);
        const obj = this.objects.get(index);
        if (!obj) {
            return;
        }
        if (obj.type === 'pen') {
            this.state.strokeColor = obj.color;
            this.state.lineWidth = obj.width || 1;
        }
        else if (obj.type === 'brush') {
            this.state.fillColor = obj.color;
        }
    }
    deleteObject(data) {
        const index = data.getUint32(0, true);
        this.objects.delete(index);
    }
}
export function renderEMF(buffer, canvas) {
    const ctx = canvas.getContext('2d');
    const renderer = new EMFRenderer(ctx);
    renderer.render(buffer);
}
//# sourceMappingURL=emf-renderer.js.map